module.exports = __webpack_public_path__ + "img/hj.41f1758b.png";